import { PRODUCER_MENU } from './producerMenu';
import userAuth, { SCOPED_BUSINESS_PERMISSIONS } from './userauth';

// UI visibility only. APIs must independently enforce permission and scope/ownership.
export const ROUTE_PERMISSIONS = {
  '/tools/admin-users': ['users.read', 'users.manage'], '/tools/admin-roles': ['roles.read', 'roles.manage'],
  '/tools/simulate-producer': ['simulator.use'], '/delegado': ['producers.delegates.read', 'producers.delegates.manage'],
  '/tools/configuration': ['configurations.read', 'configurations.manage'], '/tools/logs': ['logs.read', 'logs.manage'],
  '/adminnotificaciones': ['notifications.manage'], '/historialnotificaciones': ['notifications.read', 'notifications.manage'],
  '/admincomunicaciones': ['communications.manage'], '/historialcomunicaciones': ['communications.read', 'communications.manage'],
  '/adminleyendas': ['labels.manage'], '/auditoria-productor': ['audit.read'],
  '/tools/health': ['logs.read', 'logs.manage'],
  '/tools/statistics': ['audit.read'],
  ...Object.fromEntries(PRODUCER_MENU.filter(item => item.path).map(item => [item.path, [item.permission]])),
  '/deudores-policyExpired': ['debtors.read'], '/faq': ['resources.read'],
  '/simulator': ['simulator.manage']
};
const ADMIN_PATHS = ['/tools/health', '/tools/admin-users', '/tools/admin-roles', '/tools/configuration', '/tools/logs', '/adminnotificaciones', '/historialnotificaciones', '/admincomunicaciones', '/historialcomunicaciones', '/adminleyendas', '/auditoria-productor', '/tools/statistics'];
export const canAccessAdministration = () => userAuth.accountType() === 2 && ADMIN_PATHS.some(path => path === '/tools/statistics' ? canAccessPath(path) : userAuth.hasAnyPermission(...ROUTE_PERMISSIONS[path]));
export const canAccessPath = (path) => {
  if (!userAuth.hasCurrentSession()) return false;
  const pathname = path.split('?')[0];
  if ((ADMIN_PATHS.includes(pathname) || pathname === '/tools/simulate-producer' || pathname === '/simulator') && userAuth.accountType() !== 2) return false;
  if (pathname === '/tools') return canAccessAdministration();
  const invoice = pathname === '/consulta' && new URLSearchParams(path.split('?')[1] || '').get('data') === 'envioFactura';
  const permissions = ROUTE_PERMISSIONS[invoice ? '/consulta?data=envioFactura' : pathname];
  if (!permissions) return true;
  if (pathname === '/delegado') return userAuth.canReadDelegates();
  if (permissions.every(permission => SCOPED_BUSINESS_PERMISSIONS.has(permission))) return userAuth.hasAnyBusinessPermission(...permissions);
  return userAuth.hasAnyPermission(...permissions);
};
const MENU_PERMISSIONS = {
  ...Object.fromEntries(PRODUCER_MENU.map(item => [item.permission, [item.name]])),
  'notifications.manage': ['AdminNotificaciones'], 'communications.manage': ['AdminComunicaciones'],
  'labels.manage': ['AdminLeyendas'], 'audit.read': ['VerAuditoriaProductor'],
  'simulator.manage': ['VerSimuladores']
};
export const menuNamesForPermissions = codes => [...new Set(['Home', ...codes.flatMap(code => MENU_PERMISSIONS[code] || [])])];
export const currentMenuNames = () => menuNamesForPermissions([
  ...userAuth.permissions().filter(code => userAuth.accountType() === 2 && !SCOPED_BUSINESS_PERMISSIONS.has(code)),
  ...userAuth.businessPermissions().filter(code => SCOPED_BUSINESS_PERMISSIONS.has(code))
]).concat(canAccessPath('/tools/statistics') ? ['VerEstadisticas'] : []);
